import { render } from "./SpeakerCard.vue?vue&type=template&id=c5be15ce"
import script from "./SpeakerCard.vue?vue&type=script&lang=ts"
export * from "./SpeakerCard.vue?vue&type=script&lang=ts"

import "./SpeakerCard.vue?vue&type=style&index=0&id=c5be15ce&lang=postcss"
script.render = render

export default script